module.exports = __webpack_public_path__ + "static/img/RAKU3_1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/produkty/RAKU3_1.png
// module id = YHAF
// module chunks = 0